// assets/imgbb-upload.js
(function() {
  const IMGBB_API_KEY = 'YOUR_IMGBB_API_KEY_HERE'; // ← API KEY BURAYA

  // customImageData input'unu dinle (personalize-module'den gelecek)
  const observer = new MutationObserver(function() {
    const imageInput = document.getElementById('customImageData');
    
    if (imageInput && imageInput.value && imageInput.value.includes('data:image')) {
      // Base64 veri var, ImgBB'ye gönder
      if (!imageInput.dataset.uploaded) {
        imageInput.dataset.uploaded = 'true';
        uploadToImgBB(imageInput.value);
      }
    }
  });

  observer.observe(document.body, { 
    attributes: true, 
    subtree: true, 
    attributeFilter: ['value'] 
  });

  async function uploadToImgBB(base64String) {
    try {
      console.log('ImgBB upload başlıyor...');
      
      const formData = new FormData();
      const base64Clean = base64String.split(',')[1];
      formData.append('image', base64Clean);

      const response = await fetch(`https://api.imgbb.com/1/upload?key=${IMGBB_API_KEY}`, {
        method: 'POST',
        body: formData
      });

      if (!response.ok) {
        console.error('ImgBB upload başarısız:', response.status);
        return;
      }

      const data = await response.json();
      if (!data.data || !data.data.url) {
        console.error('ImgBB response eksik:', data);
        return;
      }

      const imageUrl = data.data.url;
      console.log('ImgBB URL döndü:', imageUrl);

      // Formlara URL'yi ekle
      addUrlToAllForms(imageUrl);

    } catch (error) {
      console.error('ImgBB upload hatası:', error);
    }
  }

  function addUrlToAllForms(imageUrl) {
    // Tüm add-to-cart form'larını bul
    const forms = document.querySelectorAll(
      'form[action="/cart/add"], form[action*="/cart/add"], product-form form'
    );

    console.log('Form sayısı:', forms.length);

    forms.forEach((form, idx) => {
      // Zaten var mı kontrol et
      if (form.querySelector('input[name="properties[_custom_image_url]"]')) {
        console.log('Form', idx, '- URL zaten var, geç');
        return;
      }

      // Yeni input oluştur
      const urlInput = document.createElement('input');
      urlInput.type = 'hidden';
      urlInput.name = 'properties[_custom_image_url]';
      urlInput.value = imageUrl;
      form.appendChild(urlInput);

      console.log('Form', idx, '- URL eklendi:', imageUrl.substring(0, 50) + '...');
    });
  }
})();